module.exports = __webpack_public_path__ + "img/icon-login-grey.83598d77.png";